import { API_TEMPLATE } from 'src/libs/constant'
import { get, post } from 'src/libs/query'

const reviewDemoApi = {
  filter (payload, queryString) {
    return post(
      API_TEMPLATE.REVIEW_CLASS_DEMO_FILTER,
      { ...payload, sortOrders: queryString?.sortOrders }
    )
  },
  detail (id) {
    return get(`${API_TEMPLATE.REVIEW_CLASS_DEMO_DETAIL}?id=${id}`)
  },
  assignBatchReviewDemo (payload) {
    return post(
      API_TEMPLATE.REVIEW_CLASS_DEMO_ASSIGN_BATCH,
      payload
    )
  },
  importGGSheet ({ sheetId, sheetName }) {
    return post(
      API_TEMPLATE.REVIEW_CLASS_DEMO_IMPORT,
      { sheetId, sheetName }
    )
  },
  exportGGSheet ({ sheetId, sheetName, criteria, sortOrders }) {
    const query = `sheetId=${encodeURIComponent(sheetId)}&sheetName=${encodeURIComponent(sheetName || '')}`
    return post(
      `${API_TEMPLATE.REVIEW_CLASS_DEMO_EXPORT}?${query}`,
      { criteria, sortOrders }
    )
  },
  update (payload) {
    return post(
      API_TEMPLATE.REVIEW_CLASS_DEMO_UPDATE,
      payload
    )
  }
}
export default reviewDemoApi
